import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from "react-router-dom";
import Header from './Components/Header';
import ProductDetails from './Components/Product-details';
import AddNew from './Components/Add';
import Footer from './Components/Footer';
import EnAttente from './Components/Commandes/En_attente';
import Login from './Components/login';
import AccessDenied from './Components/Access_denied';
import OverlayWrapper from './Components/Add/OverlayWrapper';
import Update from './Components/Update';
import Success from './Components/Commandes/Success';
import Confirmée from './Components/Commandes/Confirmée';
const App = () => {
  const [activeMenuItem, setActiveMenuItem] = useState('Accueil');
  const [logIn, setLogIn] = useState(false);
  const [render,setRender] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const checkAuthentication = () => {
    const user = JSON.parse(localStorage.getItem('userEcommerce'));
    const expirationDate = localStorage.getItem('expirationDateEcommerce');
  
    if (user && expirationDate) {
      const currentTime = new Date().getTime();
      if (currentTime < expirationDate) {
        setLogIn(true)
      }
    }
    else{
      setLogIn(false)
    }
  };
  
  const renderComponent = () => {
    const user = JSON.parse(localStorage.getItem('userEcommerce'));
    const expirationDate = localStorage.getItem('expirationDateEcommerce');
  
    if (user && expirationDate) {
      const currentTime = new Date().getTime();
      if (currentTime < expirationDate) {
        return true
      }
    }
    else{
      return false
    }
  };


  useEffect(() => {
    checkAuthentication();
  }, [render]);

  return (
    <OverlayWrapper isLoading={isLoading}>
    <div>
      <Header logIn={logIn} setLogIn={setLogIn} render={render} setRender={setRender} activeMenuItem={activeMenuItem}/>
      <Routes>
        <Route path="/login" element={<Login setLogIn={setLogIn} setActiveMenuItem={setActiveMenuItem}/>} />
        <Route path="/" element={<ProductDetails setActiveMenuItem={setActiveMenuItem} setIsLoading={setIsLoading}/>} />
        <Route path="/ajouter-produit" element={ renderComponent() ? ( <AddNew setIsLoading={setIsLoading} setActiveMenuItem={setActiveMenuItem}/>) : ( <Navigate to="/access-denied" replace /> )}/>

        <Route path="/mise-à-jour" element={ renderComponent() ? ( <Update setIsLoading={setIsLoading} setActiveMenuItem={setActiveMenuItem}/>) : ( <Navigate to="/access-denied" replace /> )}/>
        
        <Route path="/commandes/en-attente" element={ renderComponent() ? ( <EnAttente setActiveMenuItem={setActiveMenuItem} setIsLoading={setIsLoading}/>) : ( <Navigate to="/access-denied" replace /> )}/>

        <Route path="/commandes/confirmées" element={ renderComponent() ? ( <Confirmée setActiveMenuItem={setActiveMenuItem} setIsLoading={setIsLoading}/>) : ( <Navigate to="/access-denied" replace /> )}/>

        <Route path="/commande-succès-page" element={ <Success />}/>

        <Route path="/access-denied" element={<AccessDenied />} />
      </Routes>
      <Footer />
    </div>
    </OverlayWrapper>
  );
};

export default App;
